export const addAccountData = {
  awaitingInfoAccount: {
    id: '32073bde-2d2f-4687-b33c-5ce2b1e8dca6',
    profileStatus: 'AWAITING_INFORMATION',
    status: 'CREATED'
  },
  creationInProgressAccount: {
    id: '32073bde-2d2f-4687-b33c-5ce2b1e8dca6',
    profileStatus: 'CREATION_IN_PROGRESS',
    status: 'CREATED'
  }
};

export const addAccountResponse = {
  status: 200,
  contentType: 'application/json',
  body: JSON.stringify(addAccountData.awaitingInfoAccount)
};
